import { isEqual } from 'lodash-es'
import { useEffect, useRef, useState } from 'react'

const getDefaultOptions = () => {
  return {
    slidesPerView: 'auto',
    hasNavigation: false,
  }
}

const parseOptions = options => {
  let { responsive = [], ...baseOptions } = options

  let result = {
    ...getDefaultOptions(),
    ...baseOptions,
  }

  for (let { breakpoint, ...options } of responsive) {
    if (matchMedia(`(min-width: ${breakpoint})`).matches) {
      result = { ...result, ...options }
    }
  }

  return result
}

const useSpec = options => {
  let [spec, setSpec] = useState(getDefaultOptions())

  let handler = useRef()

  handler.current = () => {
    let newSpec = parseOptions(options)
    if (!isEqual(spec, newSpec)) {
      setSpec(newSpec)
    }
  }

  useEffect(() => {
    handler.current()
  }, [options])

  useEffect(() => {
    let listener = () => {
      handler.current()
    }

    listener()
    window.addEventListener('resize', listener)

    return () => {
      window.removeEventListener('resize', listener)
    }
  }, [])

  return { spec }
}

export default useSpec
